import moment from 'moment';
import queryString from 'qs';

export const getReportAccountPlatformRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.accountPlatform?.startedAt) queries['startedAt'] = moment(queryParams?.accountPlatform?.startedAt).format('YYYY-MM-DD');
  if (queryParams?.accountPlatform?.endedAt) queries['endedAt'] = moment(queryParams?.accountPlatform?.endedAt).format('YYYY-MM-DD');
  if (queryParams?.accountPlatform?.accountType?.length)
    queries['accountTypeName'] = `[${queryParams?.accountPlatform?.accountType?.map((item) => item?.value)}]`;
  if (queryParams?.accountPlatform?.brand?.length) queries['brandName'] = `[${queryParams?.accountPlatform?.brand?.map((item) => item?.value)}]`;
  if (queryParams?.accountPlatform?.platform?.length) queries['ecommerceName'] = `[${queryParams?.accountPlatform?.platform?.map((item) => item?.label)}]`;
  if (queryParams?.accountPlatform?.account?.length) queries['accountName'] = `[${queryParams?.accountPlatform?.account?.map((item) => item?.label)}]`;
  if (queryParams?.search) queries['search'] = queryParams?.search;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getReportAccountPlatformRequest;
